import React, { useState, useEffect } from 'react';
import { Container, Tab, Tabs, Placeholder,Row, Col, Card,Image } from 'react-bootstrap';
import AwardIcon from '../assets/images/award-icon.png';
import AwardIconSilver from '../assets/images/award-icon-silver.png';

const ConvocationAward = ({sp}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const tabsToShow = sp?.sp_id === 260 ? [23, 24, 25] : sp?.sp_id === 303 ? [26, 27, 28] : sp?.sp_id === 310 ? [29, 30, 31] : sp?.sp_id === 337 ? [34, 35, 33] : sp?.sp_id === 374 ? [46, 45, 47] : [];
    const staticNames = appLanguage === 'hi' ? ["चांसलर स्वर्ण पदक प्राप्तकर्ता", "कुलपति स्वर्ण पदक प्राप्तकर्ता", "अनुकरणीय प्रदर्शन रजत पट्टिका प्राप्तकर्ता"] : ["Chancellor s Gold Medal Recipients", "Vice-Chancellor s Gold Medal Recipients", "Exemplary Performance Silver Plaque Recipients"];
    // State to hold the fetched MiscellaneousType for each tab
    const [miscellaneousData, setMiscellaneousData] = useState({
        23: null,
        24: null,
        25: null,
        26: null,
        27: null,
        28: null,
        29: null,
        30: null,
        31: null,
        34: null,
        35: null,
        33: null,
        46: null,
        45: null,
        47: null,
    });

    const [loading, setLoading] = useState({
        23: true,
        24: true,
        25: true,
        26: true,
        27: true,
        28: true,
        29: true,
        30: true,
        31: true,
        34: true,
        35: true,
        33: true,
        46: null,
        45: null,
        47: null,
    });
    // Fetch data when the component mounts
    useEffect(() => 
    {
        if(sp?.sp_id === 260)
        {
            [23, 24, 25].forEach((mtid) => {
                fetchMiscellaneousType(mtid);
            });
        }
        if(sp?.sp_id === 303)
        {
            [26, 27, 28].forEach((mtid) => {
                fetchMiscellaneousType(mtid);
            });
        }
        if(sp?.sp_id === 310)
        {
            [29, 30, 31].forEach((mtid) => {
                fetchMiscellaneousType(mtid);
            });
        }
        if(sp?.sp_id === 337)
        {
            [34, 35, 33].forEach((mtid) => {
                fetchMiscellaneousType(mtid);
            });
        }
        if(sp?.sp_id === 374)
        {
            [46, 45, 47].forEach((mtid) => {
                fetchMiscellaneousType(mtid);
            });
        }      
    }, [sp]);
    const fetchMiscellaneousType = async (mtid) => 
    {
        try 
        {
            const response = await fetch(global.config.API_URL + "miscellaneousType/byId/" + mtid);
            const result = await response.json();
            setMiscellaneousData(prev => ({ ...prev, [mtid]: result }));
        } 
        catch (error) 
        {
            console.error('MiscellaneousType : Error', error.message);
        } 
        finally 
        {
            setLoading(prev => ({ ...prev, [mtid]: false }));
        }
    };
    return (
        <section style={{ backgroundImage: `url(${global.config.uploadPath + '1871784216.png'})`, backgroundSize: "cover", backgroundRepeat: "no-repeat" }}>
            <Container className="py-md-5 py-4 text-center">
                <h2 className="text-uppercase">{appLanguage === 'hi' ? 'पुरस्कार' : 'Awards'}</h2>
                <span className="mb-4 sub-heading"></span>
                <Tabs defaultActiveKey="0" className="justify-content-center mb-3">
                    {tabsToShow.map((mtid, index) => (
                        <Tab 
                            key={index} 
                            eventKey={index} 
                            title={loading[mtid] ? (
                                <Placeholder xs={6} />
                            ) : (
                                staticNames[index] || 'No Data'
                            )}
                        >
                            {loading[mtid] ? (
                                <Placeholder xs={6} />
                            ) : (
                                miscellaneousData[mtid] && miscellaneousData[mtid].length > 0 ? (
                                    <React.Fragment>
                                        <h3>{staticNames[index] || 'No Data'}</h3>
                                        <MiscellaneousList mtid={mtid} forindex={index} />
                                    </React.Fragment>
                                ) : (
                                    <h3>No Data Available</h3>
                                )
                            )}
                        </Tab>
                    ))}
                </Tabs>
            </Container>
        </section>
    );
};

export default ConvocationAward;
const MiscellaneousList = ({ mtid,forindex }) => {
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const [isLoading, setLoading] = useState(true);
    const [Miscellaneous, setMiscellaneous] = useState([]);

    useEffect(() => {
        const getMiscellaneous = async () => {
            setLoading(true);
            try {
                const response = await fetch(global.config.API_URL + "miscellaneous/byTypeAll/" + mtid);
                const result = await response.json();

                if (result.length > 0) {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFile")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFileHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => ({
                                    ...e,
                                    upp,
                                    upb
                                }));
                        })
                    ).then(allResponse => {
                        allResponse.forEach((el, i) => {
                            result[i].miscFile = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].miscFileHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setMiscellaneous(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('Miscellaneous File :', error);
                        setLoading(false);
                    });
                } else {
                    setMiscellaneous([]);
                    setLoading(false);
                }
            } catch (error) {
                console.error('MiscellaneousByType : Error', error.message);
                setLoading(false);
            }
        };
        getMiscellaneous();
    }, [mtid]);

    return (
        <React.Fragment>
            {isLoading ? (
                <Row className="row-cols-1 row-cols-sm-2 row-cols-md-5 g-3 justify-content-center">
                    {[...Array(6)].map((_, index) => (
                        <Col key={index}>
                            <Card className="shadow-lg h-100 hover-card" data-aos="flip-up" data-aos-duration="1000">
                                <Card.Body>
                                    <Placeholder xs={12} className="img-fluid rounded border mb-3" style={{ minHeight: "150px" }} />
                                    <Card.Title><Placeholder xs={10} /></Card.Title>
                                    <Card.Text><Placeholder xs={10} bg="secondary" /></Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            ) : (
                <Row className="row-cols-1 row-cols-sm-2 row-cols-md-5 g-3 justify-content-center">
                    {Miscellaneous.map((sm, index) => (
                        <Col key={index}>
                            <Card className={forindex === 2 ? "text-center text-bg-secondary bg-secondary-subtle border-4 border-secondary shadow h-100 hover-card" : "text-center text-bg-warning bg-warning-subtle border-4 border-warning shadow h-100 hover-card"} data-aos="flip-up" data-aos-duration="1000">
                                <Card.Body className="d-flex flex-column">
                                    <Image src={sm.miscFile} fluid className={forindex === 2 ? "rounded border border-secondary mb-3" : "rounded border border-warning mb-3"} />
                                    <Card.Title className={forindex === 2 ? "text-dark mt-auto" : "mt-auto"} dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? sm.sm_name_hi || sm.sm_name : sm.sm_name }}></Card.Title>
                                    <Card.Text className="text-secondary" dangerouslySetInnerHTML={{ __html: sm.sm_link }}></Card.Text>
                                    <Image src={forindex === 2 ? AwardIconSilver : AwardIcon} className="award-icon" />
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            )}
        </React.Fragment>
    );
};
